<template>
	<div class="container">
		<div class="divider">
			<div class="title">
				{{ title }}
			</div>
			<div class="icon">
				<div>
					<img width="10" class="questionmark cursor-pointer" src="/assets/images/icon-info.svg" @click="showModal" />
				</div>
			</div>
		</div>
		<SpecialRxHelpModal v-if="show" :closeButton="true" title="Other Prescripion Notes" buttonText="CLOSE" @close="closeModal"> </SpecialRxHelpModal>
	</div>
</template>

<script>
	import SpecialRxHelpModal from '@/components/modals/SpecialRxHelpModal.vue';
	import { Vue } from 'vue-property-decorator';
	import { Observer } from 'mobx-vue';
	import Component from 'vue-class-component';

	export default {
		name: 'OtherModifications',
		data: function() {
			return {
				show: false
			};
		},
		props: {
			title: String
		},
		components: {
			SpecialRxHelpModal
		},
		methods: {
			close() {
				this.$emit('close');
				this.show = false;
			},
			closeModal() {
				this.show = false;
			},
			showModal() {
				this.show = true;
			}
		}
	};
</script>

<style lang="scss" scoped>
	.divider {
		display: flex;
		align-items: center;
		text-align: center;
	}

	/* To show the lines on right 
and left sides of the text */
	.divider::after,
	.divider::before {
		content: '';
		border-top: 1px solid #cfd1d3;
		flex: 1;
	}
	.container-title {
		width: 100%;
		display: inline-grid;
		grid-template-columns: 1fr 1fr 1fr;
		align-items: center;
	}
	.title {
		font-size: 16px;
		font-weight: 400;
		letter-spacing: 0.2em;
		font-size: 15px;
		background-color: #ffffff;
		padding: 10px;
	}
	.icon {
		display: flex;
		height: 20px;
		margin-top: -25px;
		padding-right: 5px;
		cursor: pointer;
	}
	.container {
		width: 100%;
	}
</style>
